import { useEffect } from 'react';

// Live "seen by" updates for the reply/note avatar stack. Deliberately a
// separate listener from useEchoUpdateTicket (same 'ticket.{id}' channel,
// different event name) so it never touches the generic changedColumns
// redux flow that drives the ticket-properties toast/refetch.
export default function useEchoCommentSeen(ticketId, onSeen) {
    useEffect(() => {
        if (!ticketId) return undefined;

        const channel = window.Echo.channel('ticket.' + ticketId);
        channel.listen('.CommentSeenUpdated', (e) => {
            onSeen?.(e);
        });

        return () => {
            channel.stopListening('.CommentSeenUpdated');
        };
    }, [ticketId, onSeen]);
}
